import {useEffect, useState} from 'react';

/** Set on `<html>` while Shop the Look product drawer is open (desktop + mobile). */
export const SHOP_THE_LOOK_DRAWER_OPEN_CLASS = 'shop-the-look-drawer-open';

export function setShopTheLookDrawerDocumentOpen(isOpen) {
  if (typeof document === 'undefined') return;

  document.documentElement.classList.toggle(SHOP_THE_LOOK_DRAWER_OPEN_CLASS, Boolean(isOpen));
}

/**
 * Tracks Shop the Look product drawer open state via `html.shop-the-look-drawer-open`.
 * Used to lower z-index of global overlays (e.g. showroom selection popup) below the drawer.
 */
export function useShopTheLookDrawerOpen() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const root = document.documentElement;

    const sync = () => {
      setIsOpen(root.classList.contains(SHOP_THE_LOOK_DRAWER_OPEN_CLASS));
    };

    sync();

    const observer = new MutationObserver(sync);
    observer.observe(root, {attributes: true, attributeFilter: ['class']});

    return () => observer.disconnect();
  }, []);

  return isOpen;
}
